import Box from '@mui/material/Box';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useAppDrawerInRedux} from 'hooks';
import {DrawerContent} from './DrawerContent';
import {DrawerHeader} from './DrawerHeader';
import MiniDrawerStyled from './MiniDrawerStyled';

export interface MainDrawerProps {
    window?: () => Window;
}

export const MainDrawer: React.FC<MainDrawerProps> = ({window, ...rest}) => {
    const theme = useTheme();
    const downLG = useMediaQuery(theme.breakpoints.down('lg'));
    const {isDrawerOpened, setIsAppDrawerOpenInRedux} = useAppDrawerInRedux();
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box component="nav" sx={{flexShrink: {md: 0}, zIndex: 1200}}>
            <MiniDrawerStyled variant={'permanent'} open={isDrawerOpened}>
                <DrawerHeader open={isDrawerOpened} />
                <DrawerContent {...rest} />
            </MiniDrawerStyled>
        </Box>
    );
};
export default MainDrawer;
